import React, { useState } from "react";
import { PendingTransactionsIcon, EarnedPointIcon } from "@util/svgicon"
import SummaryIcon from '@images/dashboard/format_list_bulleted.svg'
import { DateTime } from 'luxon';
import { getDaySuffix } from '@util/config';

const RightSection = () => {

  const [scoredDriveData, setScoredDriveData] = useState([]);
  const [unscoredDriveData, setUnscoredDriveData] = useState([]);

  return (
    <div className="w-full">
      <div className="flex h-full p-[36px] flex-col items-start gap-[24px] backdrop-blur-3xl">
        <TranscriptSection
          unscoredDriveData={unscoredDriveData}
          scoredDriveData={scoredDriveData}
        />
      </div>
    </div>
  );
};

const TranscriptSection = ({ unscoredDriveData, scoredDriveData }) => {
  return (
    <>
      <div className="w-full flex items-center gap-[8px]">
        <img src={SummaryIcon} alt="SummaryIcon" className="w-[24px] h-[24px]" />
        <p className="text-lg font-medium text-gray">FBP Summary</p>
      </div>
      <div className='w-full flex flex-col items-start gap-[4px]'>
        <div className='w-full flex pt-0 pr-[8px] pb-[8px] pl-0 justify-between items-center'>
          <div className='flex items-center gap-[16px]'>
            <div className='flex items-center gap-[8px]'>
              <PendingTransactionsIcon />
              <p className='text-[#282828] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Pending transactions</p>
            </div>
          </div>
        </div>
        <table className='w-full flex flex-col px-[16px] py-[8px] justify-between items-center'>
          <thead className='w-full flex px-[16px] py-[8px] justify-between items-center rounded-[8px]'>
            <tr className='w-full flex px-[16px] py-[8px] justify-between rounded-[8px]'>
              <th className='w-[50%] text-start text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date/Time</th>
              <th className='w-[50%] flex justify-end items-center'>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date</div>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Activity</div>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Points Earned</div>
              </th>
            </tr>
          </thead>
          <tbody className='w-full flex flex-col px-[16px] py-[8px] items-center gap-[24px] rounded-[8px] bg-[#FAFAFA]'>
            {unscoredDriveData
              .map((item, index) => (
                <UnscoredDriveHistory
                  item={item}
                  index={index}
                />
              ))
            }
          </tbody>
        </table>
      </div>
      <div className='w-full flex flex-col items-start gap-[4px]'>
        <div className='w-full flex pt-0 pr-[8px] pb-[8px] pl-0 justify-between items-center'>
          <div className='flex items-center gap-[16px]'>
            <div className='flex items-center gap-[8px]'>
              <EarnedPointIcon />
              <p className='text-[#282828] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Earned points</p>
            </div>
          </div>
        </div>
        <table className='w-full flex flex-col px-[16px] py-[8px] justify-between items-center'>
          <thead className='w-full flex px-[16px] py-[8px] justify-between items-center rounded-[8px]'>
            <tr className='w-full flex px-[16px] py-[8px] justify-between rounded-[8px]'>
              <th className='w-[50%] text-start text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date/Time</th>
              <th className='w-[50%] flex justify-end items-center'>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date</div>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Activity</div>
                <div className='w-[25%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Points Earned</div>
              </th>
            </tr>
          </thead>
          <tbody className='w-full flex flex-col px-[16px] py-[8px] items-center gap-[24px] rounded-[8px] bg-[#FAFAFA]'>
            {scoredDriveData.map((item, index) => (
              <ScoredDriveHistory
                item={item}
                index={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

const UnscoredDriveHistory = ({ item, index }) => {

  const startTime = DateTime.fromISO(item?.start_time);
  const day = startTime.day;
  const month = startTime.toFormat('MMMM');
  const year = startTime.year;
  const dayWithSuffix = day + getDaySuffix(day);

  const experiencePoints = item?.experience_points / 10;
  const distance = item?.distance / 1000;
  const distanceRoundNumber = Math.round(distance * 100) / 100;
  const experiencePointsRoundNumber = Math.round(experiencePoints * 100) / 100;
  const qualifiedMilesRoundNumber = Math.round(item?.qualified_miles * 100) / 100;

  const startTimes = new Date(item?.start_time);
  const endTimes = new Date(item?.end_time);
  const differenceInSeconds = (endTimes - startTimes) / 1000;
  const differenceInMinutes = differenceInSeconds / 60;

  return (
    <tr key={index} className='w-full flex justify-between items-center'>
      <div className='flex flex-col justify-center items-start'>
        <td className='text-[#282828] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{item.botName} Drive</td>
        <td className='flex items-center gap-[4px] text-[#727272] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'> Start: {`${dayWithSuffix} ${month} ${year}`} - Duration: {differenceInMinutes.toFixed(2)} min</td>
      </div>
      <div className='w-[50%] flex justify-end items-center'>
        <td className='w-[25%] text-[#727272] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{distanceRoundNumber ? distanceRoundNumber : '---'}</td>
        <td className='w-[25%] text-[#0A6AF3] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{experiencePointsRoundNumber ? experiencePointsRoundNumber : '---'}</td>
        <td className='w-[25%] text-[#0A6AF3] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{qualifiedMilesRoundNumber ? qualifiedMilesRoundNumber : '---'}</td>
      </div>
    </tr>
  )
}

const ScoredDriveHistory = ({ item, index }) => {

  const startTime = DateTime.fromISO(item?.start_time);
  const day = startTime.day;
  const month = startTime.toFormat('MMMM');
  const year = startTime.year;
  const dayWithSuffix = day + getDaySuffix(day);

  const experiencePoints = item?.experience_points / 10;
  const distance = item?.distance / 1000;
  const distanceRoundNumber = Math.round(distance * 100) / 100;
  const experiencePointsRoundNumber = Math.round(experiencePoints * 100) / 100;
  const qualifiedMilesRoundNumber = Math.round(item?.qualified_miles * 100) / 100;

  const startTimes = new Date(item?.start_time);
  const endTimes = new Date(item?.end_time);
  const differenceInSeconds = (endTimes - startTimes) / 1000;
  const differenceInMinutes = differenceInSeconds / 60;

  return (
    <tr key={index} className='w-full flex justify-between items-center'>
      <div className='flex flex-col justify-center items-start'>
        <td className='text-[#282828] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{item.botName} Drive</td>
        <td className='flex items-center gap-[4px] text-[#727272] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'> Start: {`${dayWithSuffix} ${month} ${year}`} - Duration: {differenceInMinutes.toFixed(2)} min</td>
      </div>
      <div className='w-[50%] flex justify-end items-center'>
        <td className='w-[25%] text-[#727272] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{distanceRoundNumber ? distanceRoundNumber : '---'}</td>
        <td className='w-[25%] text-[#008735] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{experiencePointsRoundNumber ? experiencePointsRoundNumber : '---'}</td>
        <td className='w-[25%] text-[#0A6AF3] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{qualifiedMilesRoundNumber ? qualifiedMilesRoundNumber : '---'}</td>
      </div>
    </tr>
  )
}

export default RightSection;